import { render, staticRenderFns } from "./Menu_Message.vue?vue&type=template&id=473f978f&"
import script from "./Menu_Message.vue?vue&type=script&lang=js&"
export * from "./Menu_Message.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports